import { Ellipsis } from 'lucide-react';
import { Button } from '../../primitives/button.js';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../../primitives/dropdown-menu.js';
import { resolveConfirm } from '../confirm.js';
import type { ConfirmSpec, RowAction } from '../types.js';

export interface RowActionsProps<TItem> {
  row: TItem;
  actions: readonly RowAction<TItem>[];
  onConfirm: (
    spec: ConfirmSpec,
    tone: 'default' | 'danger',
    run: () => void | Promise<void>,
  ) => void;
}

export function RowActions<TItem>({ row, actions, onConfirm }: RowActionsProps<TItem>) {
  const visible = actions.filter((action) => action.visible?.(row) ?? true);
  if (visible.length === 0) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon-sm" aria-label="Azioni">
          <Ellipsis />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {visible.map((action) => (
          <DropdownMenuItem
            key={action.id}
            tone={action.tone}
            disabled={action.disabled?.(row) ?? false}
            onSelect={() => {
              const spec = resolveConfirm(action.confirm, row);
              const run = () => action.onSelect(row);
              if (spec) onConfirm(spec, action.tone ?? 'default', run);
              else void run();
            }}
          >
            {action.icon}
            {action.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
